// extracted by mini-css-extract-plugin
module.exports = {"image":"-button-image-229QQ2-"};